import { FC, ReactNode, useEffect, useRef, useState } from "react";

export interface WcagTriggerRenderProps {
  isOpen: boolean;
  onFocus: () => void;
  onBlur: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onTouchStart: () => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLElement>) => void;
  "data-tooltip-trigger": true;
}

interface WcagTooltipWrapperProps {
  touchAutoHideMs?: number;
  renderTrigger: (props: WcagTriggerRenderProps) => ReactNode;
  renderTooltip: (isOpen: boolean) => ReactNode;
}

const WcagTooltipWrapper: FC<WcagTooltipWrapperProps> = ({
  touchAutoHideMs,
  renderTrigger,
  renderTooltip,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef<number | null>(null);

  const clearTouchTimeout = () => {
    if (timeoutRef.current !== null) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const handleTouchStart = () => {
    clearTouchTimeout();
    setIsOpen(true);

    if (touchAutoHideMs) {
      timeoutRef.current = window.setTimeout(() => {
        setIsOpen(false);
        timeoutRef.current = null;
      }, touchAutoHideMs);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === "Escape") {
      setIsOpen(false);
      (event.currentTarget as HTMLElement).blur();
    }
  };

  useEffect(
    () => () => {
      clearTouchTimeout();
    },
    []
  );

  const triggerProps: WcagTriggerRenderProps = {
    isOpen,
    onFocus: () => setIsOpen(true),
    onBlur: () => setIsOpen(false),
    onMouseEnter: () => setIsOpen(true),
    onMouseLeave: () => setIsOpen(false),
    onTouchStart: handleTouchStart,
    onKeyDown: handleKeyDown,
    "data-tooltip-trigger": true as const,
  };

  return (
    <>
      {renderTrigger(triggerProps)}
      {renderTooltip(isOpen)}
    </>
  );
};

export default WcagTooltipWrapper;


